import React, { useState } from "react";
import Logo from "../assets/logo-color.png";
import { HiOutlineMail } from "react-icons/hi";
import { FaBars, FaTimes } from "react-icons/fa";
import { BsFileEarmarkPersonFill } from "react-icons/bs";
import { FaLinkedin, FaTwitter, FaGithub } from "react-icons/fa";
import { Link } from "react-scroll";
import ResumePDF from "../assets/Jayant_Ghadge_Resume_2024.pdf";

const Navbar = () => {
  const [nav, setNav] = useState(false);
  const handleClick = () => setNav(!nav);

  const handleResumeDownload = () => {
    window.location.href = ResumePDF;
  };

  return (
    <div className="flex fixed top-0 z-20 justify-between items-center py-4 px-4 w-full h-20 border-b backdrop-blur-md border-salte-900/10 text-slate-50 lg:px-8 lg:border-0 dark:border-slate-300/10">
      <div className="logo">
        <img src={Logo} />
      </div>

      {/* menu */}
      <ul className="hidden flex-row md:flex">
        <li className="hover:text-white/70 nav-link">
          <Link
            activeClass="active"
            to="home"
            smooth={true}
            offset={10}
            duration={500}
          >
            Home
          </Link>
        </li>
        <li className="hover:text-white/70 nav-link">
          <Link
            activeClass="active"
            to="about"
            smooth={true}
            offset={50}
            duration={500}
          >
            About
          </Link>
        </li>
        <li className="hover:text-white/70 nav-link">
          <Link
            activeClass="active"
            to="skills"
            smooth={true}
            offset={-50}
            duration={500}
          >
            Skills
          </Link>
        </li>
        <li className="hover:text-white/70 nav-link">
          <Link
            activeClass="active"
            to="work"
            smooth={true}
            offset={-50}
            duration={500}
          >
            Work
          </Link>
        </li>
        <li className="hover:text-white/70 nav-link">
          <Link
            activeClass="active"
            to="contact"
            smooth={true}
            offset={-80}
            duration={500}
          >
            Contact
          </Link>
        </li>
      </ul>

      {/* Hamburger */}
      <div onClick={handleClick} className="z-10 mr-3 md:hidden">
        {!nav ? <FaBars /> : <FaTimes />}
      </div>

      {/* mobile menu */}
      <div
        className={
          !nav
            ? "hidden"
            : "mobile-menu fixed inset-0 h-screen flex flex-col justify-center items-center bg-gradient-to-br from-[#0F172A] to-[#183250]"
        }
      >
        <ul>
          <li>
            <Link
              onClick={handleClick}
              activeClass="active"
              to="home"
              smooth={true}
              offset={-200}
              duration={500}
            >
              Home
            </Link>
          </li>
          <li>
            <Link
              onClick={handleClick}
              activeClass="active"
              to="about"
              smooth={true}
              offset={-20}
              duration={500}
            >
              About
            </Link>
          </li>
          <li>
            <Link
              onClick={handleClick}
              activeClass="active"
              to="skills"
              smooth={true}
              offset={-30}
              duration={500}
            >
              Skills
            </Link>
          </li>
          <li>
            <Link
              onClick={handleClick}
              activeClass="active"
              to="work"
              smooth={true}
              duration={500}
            >
              Work
            </Link>
          </li>
          <li>
            <Link
              onClick={handleClick}
              activeClass="active"
              to="contact"
              smooth={true}
              offset={100}
              duration={500}
            >
              Contact
            </Link>
          </li>
        </ul>
        <div>
          <ul className="flex gap-x-6 mt-12">
            <li className="bg-[#1d1d1e] p-2 rounded-md cursor-pointer">
              <a href="https://github.com/jayantghadge">
                <span>
                  <FaGithub className="w-6 h-8" />
                </span>
              </a>
            </li>
            <li className="bg-[#00A6ED] p-2 rounded-md cursor-pointer">
              <a href="https://www.linkedin.com/in/jayant-ghadge-700739181">
                <span>
                  <FaLinkedin className="w-6 h-8" />
                </span>
              </a>
            </li>
            <li className="bg-[#0378c7] p-2 rounded-md cursor-pointer">
              <a href="https://twitter.com/JayantGhadge">
                <span>
                  <FaTwitter className="w-6 h-8" />
                </span>
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* Social Icons */}
      <div className="fixed top-[200px] left-0 hidden lg:flex flex-col">
        <ul className="social-icons">
          <li className="bg-[#1d1d1e]">
            <a href="https://github.com/jayantghadge">
              Github
              <FaGithub className="mr-2 w-6 h-6" />
            </a>
          </li>
          <li className="bg-[#00A6ED]">
            <a href="https://www.linkedin.com/in/jayant-ghadge-700739181">
              LinkedIn
              <FaLinkedin className="mr-2 w-6 h-6" />
            </a>
          </li>
          <li className="bg-[#dc5482]">
            <a
              href="/path/to/resume.pdf"
              onClick={handleResumeDownload}
              download="resume.pdf"
            >
              Resume
              <BsFileEarmarkPersonFill className="mr-2 w-6 h-6" />
            </a>
          </li>
          <li className="bg-[#0378c7]">
            <a href="https://twitter.com/JayantGhadge">
              Twitter
              <FaTwitter className="mr-2 w-6 h-6" />
            </a>
          </li>
          <li className="bg-[#6aa66a]">
            <a href="mailto:jayantghadge6@gmail.com">
              Email
              <HiOutlineMail className="mr-2 w-6 h-6" />
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Navbar;
